module.exports = "<svg viewBox=\"0 0 24 24\"><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"/><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/lock.svg
// module id = vuvZ
// module chunks = 0